import React from 'react';
import classNames from 'classnames';
import Slider from 'react-slick';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import CtaButton from '../../../../components/elements/CtaButton';
import { SectionPaddingSide, SectionPaddingVertical } from '../../../../components/global/Layout';
import CtaButtonContainer from '../../../../components/elements/CtaButton/CtaButtonContainer';
import { getCurriculumVariantData } from './curriculumData';
const styles = require('./Curriculum.module.css');

const CTA_DATA_LOCATION = 'curriculum';

function Curriculum({ onCtaClick, title, subtitle, curriculum, ctaLabel, backgroundColor }) {
  const handleCtaClick = e => {
    onCtaClick(e, CTA_DATA_LOCATION);
  };

  return (
    <SectionPaddingVertical className={styles.curriculumSection} style={{ backgroundColor }}>
      <SectionPaddingSide>
        <CodeSparkThemedTypography variant="h2" className={styles.curriculumTitle}>
          {title}
        </CodeSparkThemedTypography>

        <CodeSparkThemedTypography variant="subtitle1" className={styles.curriculumSubtitle}>
          {subtitle}
        </CodeSparkThemedTypography>

        <CurriculumRow curriculum={curriculum} ctaLabel={ctaLabel} />
      </SectionPaddingSide>

      <CurriculumSlider curriculum={curriculum} ctaLabel={ctaLabel} />

      <CtaButtonContainer className={styles.curriculumCtaContainer}>
        <CtaButton
          type="primary"
          data-event-action="homepage-curriculum"
          data-event-label={ctaLabel}
          onClick={handleCtaClick}
        >
          {ctaLabel}
        </CtaButton>
      </CtaButtonContainer>
    </SectionPaddingVertical>
  );
}

const slickSettings = {
  dots: true,
  infinite: true,
  speed: 600,
  draggable: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dotsClass: `slick-dots ${styles.curriculumSliderDots}`,
};

function CurriculumSlider({ curriculum }) {
  return (
    <div className={styles.curriculumSlider}>
      <Slider {...slickSettings}>
        {curriculum.map((item, i) => {
          return (
            // Need wrapper or else react-slick will overwrite the style for bg
            <div className={styles.curriculumSlide} key={`curriculum_slider_${i}`}>
              <CurriculumCard {...item} />
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

function CurriculumCard({
  backgroundColor,
  title,
  commandImage,
  gameImage,
  fooImage,
  foo,
  flipFoo,
  text,
}) {
  return (
    <div className={`cell small-12 medium-3 ${styles.curriculumCard}`} style={{ backgroundColor }}>
      <div className={styles.curriculumCardTitleWrapper}>
        <CodeSparkThemedTypography variant="h4" className={styles.curriculumCardTitle}>
          {title}
        </CodeSparkThemedTypography>
      </div>

      <div className={styles.curriculumCardCommandImageWrapper}>
        <img src={commandImage} alt={`${title} command`} />
      </div>

      <div className={styles.curriculumCardBody}>
        <div className={styles.curriculumCardImage}>
          <div className={styles.curriculumCardGameViewImageWrapper}>
            <img src={gameImage} alt={`${title} game`} />
          </div>

          <div className={styles.curriculumCardFoo}>
            <img src={fooImage} alt={foo} className={classNames({ [styles.reverse]: flipFoo })} />
          </div>
        </div>

        <CodeSparkThemedTypography variant="subtitle3" className={styles.curriculumCardBodyText}>
          {text}
        </CodeSparkThemedTypography>
      </div>
    </div>
  );
}

function CurriculumRow({ curriculum }) {
  return (
    <div className={`grid-x grid-margin-x ${styles.curriculumRow}`}>
      {curriculum.map((item, i) => (
        <CurriculumCard key={`curriculum_row_${i}`} {...item} />
      ))}
    </div>
  );
}

function CurriculumVariant({ variant, ...props }) {
  const curriculumData = getCurriculumVariantData(variant);

  return <Curriculum {...props} {...curriculumData} />;
}

export default CurriculumVariant;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/Curriculum/index.js